import { render, staticRenderFns } from "./identifier-suggestions.vue?vue&type=template&id=61d520a4&"
import script from "./identifier-suggestions.vue?vue&type=script&lang=ts&"
export * from "./identifier-suggestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports